import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { SignupForm } from '../components/signup/SignupForm';

export const SignupPage = () => {
  return (
    <AuthLayout>
      <SignupForm />
    </AuthLayout>
  );
};
